module.exports = __webpack_public_path__ + "img/logo_navbar.05d3942b.png";